import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';

export const ALink = ({
  href,
  target,
  rel,
  children,
  type = 'secondary', // default
  hideIcon = false,
  iconDirection = 'right',
  className = '',
}) => {
  const iconColor = useMemo(() => {
    switch (type) {
      case 'primary':
        return 'var(--azure-800)';
      case 'secondary':
        return 'var(--black)';
      case 'tertiary':
        return 'var(--white)';
      default:
        return 'var(--black)';
    }
  }, [type]);

  const renderIcon = () => {
    if (hideIcon) return null;

    if (iconDirection === 'left') {
      return <ArrowLeft size={16} weight="bold" color={iconColor} />;
    } else {
      return <ArrowRight size={16} weight="bold" color={iconColor} />;
    }
  };

  return (
    <div
      className={classNames('alink group', {
        'text-azure-800': type === 'primary', // accent-colored link
        'text-black': type === 'secondary', // black-colored link
        'text-white': type === 'tertiary', // white-colored link
      })}
    >
      <a
        href={href}
        target={target}
        rel={rel}
        className={classNames(
          className,
          'flex items-center gap-2 text-base font-semibold transition-smooth group-hover:gap-4',
          {
            'flex-row-reverse justify-end': iconDirection === 'right',
            'group-hover:!text-azure-800': type === 'primary',
            'group-hover:!text-black': type === 'secondary',
            'group-hover:!text-white': type === 'tertiary',
          }
        )}
      >
        {renderIcon()}
        {children}
      </a>
    </div>
  );
};

ALink.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  hideIcon: PropTypes.bool,
  iconDirection: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
};
